import { APICore } from './apiCore'

const api = new APICore()

function getQuestionSurveys (params) {
  const baseUrl = '/question-survey'
  return api.get(baseUrl, params)
}

function getQuestionSurvey (id) {
  const baseUrl = `/question-survey/${id}`
  return api.get(baseUrl, {})
}

function addQuestionSurvey (params) {
  const baseUrl = '/question-survey'
  return api.create(baseUrl, params)
}

function updateQuestionSurvey (params) {
  const baseUrl = '/question-survey'
  return api.update(baseUrl, params)
}

function deleteQuestionSurvey (params) {
  const baseUrl = '/question-survey'
  return api.delete(baseUrl, params)
}

export { getQuestionSurveys, getQuestionSurvey, addQuestionSurvey, updateQuestionSurvey, deleteQuestionSurvey }
